/**
 * Contractors the user chose to ignore in the calendar filter ("Ignorar prestador").
 *
 * The API has no "exclude contractor" parameter, so the calendar hides those tasks itself. The calendar list
 * (reducedSchedule) only carries the contractor name, so a task matches by id when it has one (live updates
 * load the full task) and otherwise by name.
 */
export interface IgnoredContractors {
  ids: string[];
  names: string[];
}

const normalizeName = (name: string | null | undefined): string =>
  (name ?? '').trim().replace(/\s+/g, ' ').toLocaleLowerCase('es');

export function ignoredContractorsOf(
  contractors: { id: unknown; fullName: string }[] | null | undefined
): IgnoredContractors {
  const list = contractors ?? [];
  return {
    ids: list.map((c) => String(c.id)),
    names: list.map((c) => normalizeName(c.fullName)).filter((n) => n !== ''),
  };
}

export function isIgnoredContractor(
  task: { contractorId?: unknown; contractorName?: string | null },
  ignored: IgnoredContractors
): boolean {
  if (task.contractorId != null && ignored.ids.includes(String(task.contractorId))) return true;
  const name = normalizeName(task.contractorName);
  return name !== '' && ignored.names.includes(name);
}
